import React from "react";
import { Link } from "react-router-dom";
import logo from '../assets/logo.png'

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-fg py-12">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="rounded-lg">
              <img src={logo} alt="logo" className="w-12 h-auto" />
            </div>
            <h3 className="text-xl font-bold">MALDROID</h3>
          </div>
          <p className="text-blue-100 text-sm">
            Malware Detection in Android Application through APK Analysis using
            Machine Learning Techniques.
          </p>
        </div>
        <div>
          <h4 className="font-bold text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2 text-blue-100 text-sm">
            <li>
              <Link to="/about" className="hover:text-white">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/policy " className="hover:text-white">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-blue-100 text-sm">
            <br />© 2026 MALDROID Project by WebHex Tech.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
